"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importDefault(require("react"));

var bar_1 = require("./styled/bar");

var root_1 = require("./styled/root");

var calculateProgress = function calculateProgress(_a) {
  var min = _a.min,
      max = _a.max,
      value = _a.value;
  var progress = value - min;
  var offsetMax = max - min;

  if (max <= 0 || min < 0 || progress <= 0) {
    return 0;
  }

  if (progress > offsetMax) {
    return 100;
  }

  return Math.round(progress / offsetMax * 100);
};

var ProgressBar = function ProgressBar(_a) {
  var __UIScope = _a.__UIScope,
      className = _a.className,
      testID = _a["data-testid"],
      _b = _a.min,
      min = _b === void 0 ? 0 : _b,
      _c = _a.max,
      max = _c === void 0 ? 100 : _c,
      _d = _a.value,
      value = _d === void 0 ? 0 : _d,
      label = _a.label,
      labelledById = _a.labelledById,
      _e = _a.layout,
      layout = _e === void 0 ? root_1.Layout.item : _e;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'ProgressBar',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var a11yProps = {};

  if (label) {
    a11yProps['aria-label'] = label;
  }

  if (labelledById) {
    a11yProps['aria-labelledby'] = labelledById;
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    "aria-label": label,
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max,
    layout: layout
  }, a11yProps), react_1.default.createElement(bar_1.Bar, {
    progress: calculateProgress({
      min: min,
      max: max,
      value: value
    }),
    layout: layout
  }));
};

var ProgressBarWithSpace = (0, ui_helper_with_space_1.withSpace)(ProgressBar);
exports.ProgressBar = ProgressBarWithSpace;